import React, { ReactElement, ReactNode, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Divider } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useRouter } from '@src/routes'
import ResponsiveModal, { ModalSizes } from '@src/components/ResponsiveModal'
import VideoPlayer from '@src/components/ProductImagesModal/VideoPlayer'
import { useUserSession } from '@utils/useUserSession'
import * as VideoURLs from './VideoUrl.json'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => {
  return {
    helpText: {
      fontSize: theme.typography.pxToRem(14),
      cursor: 'pointer',
    },
    helpLink: {
      color: theme.palette.primary.main,
    },
    divider: {
      margin: `0px ${theme.spacing(2)}px`,
      width: 1,
      height: 20,
    },
    popupTitle: {
      fontSize: theme.typography.pxToRem(18),
    },
    watchTutorial: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 900,
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
    videoCloseButton: {
      zIndex: 10,
    },
  }
})

const ConfiguratorVideoTutorial: React.FC<{
  insertVideoLink?: (e: ReactElement) => ReactNode
  className?: string
}> = ({ insertVideoLink, className }) => {
  const classes = useStyles()
  const router = useRouter()
  const [tutorialModalOpen, setTutorialModalOpen] = useState<boolean>(false)
  const { userSession } = useUserSession()
  const country = userSession.country
  let { product = '' } = router.query
  if (router.pathname === '/[country]/[language]/configurators/milliplex')
    product = 'milliplex'
  if (router.pathname === '/[country]/[language]/configurators/ngso')
    product = 'ngso'

  const videoTutorial =
    VideoURLs[product.toUpperCase()]?.[country] ??
    VideoURLs[product.toUpperCase()]?.['DEFAULT']

  const openVideoTutorial = () => {
    setTutorialModalOpen(true)
  }
  const handleTutorialModalClose = () => {
    setTutorialModalOpen(false)
  }

  const tutorialLink = (
    <div
      onKeyDown={openVideoTutorial}
      role="button"
      tabIndex={0}
      className={clsx(
        classes.watchTutorial,
        className && { [String(className)]: className }
      )}
      onClick={openVideoTutorial}
    >
      <FormattedMessage
        id="CONF_VIDEO_WATCH_TUTORIAL"
        defaultMessage="Watch Tutorial"
      />
    </div>
  )
  return (
    <>
      {videoTutorial && (
        <>
          {insertVideoLink ? (
            insertVideoLink(tutorialLink)
          ) : (
            <>
              {tutorialLink}
              <Divider className={classes.divider} />
            </>
          )}
          <ResponsiveModal
            size={ModalSizes.Large}
            customCloseBtnStyle={classes.videoCloseButton}
            open={tutorialModalOpen}
            onClose={handleTutorialModalClose}
          >
            <VideoPlayer
              videoUrl={videoTutorial}
              posterUrl={
                'https://www.sigmaaldrich.com/deepweb/assets/sigmaaldrich/marketing/global/images/video-posters/configurators-plate/configurators-plate.png'
              }
              css={classes.helpLink}
              name={''}
              brand={''}
              productId={''}
              autoPlay
            />
          </ResponsiveModal>
        </>
      )}
    </>
  )
}

export default ConfiguratorVideoTutorial
